// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__Piw61","date":"Privacy_date__PHWCF"};